import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import useStyles from "./HRModelerAnalyticsGlobal.styles";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import HRModelerAnalyticsGlobalFiltersAndReports from "./HRModelerAnalyticsGlobalFiltersAndReports.component";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";
import { EmailProvider } from "../../../context/EmailContext";
import { ApprovalProvider } from "../../../context/ApprovalContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const HRModelerAnalyticsGlobal = ({ toCompare = false } = {}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <ApprovalProvider>
              <EmailProvider>
                <HRModelerAnalyticsGlobalFiltersAndReports
                  toSave={true}
                  toCompare={toCompare}
                  toDisableEntitySelection={false}
                  reportLocated={"LEFT"}
                />
              </EmailProvider>
            </ApprovalProvider>
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>
        {toCompare && (
          <HedgeRatioProvider>
            <TreasuryKRISummaryProvider>
              <ApprovalProvider>
                <EmailProvider>
                  <HRModelerAnalyticsGlobalFiltersAndReports
                    toSave={false}
                    toCompare={toCompare}
                    toDisableEntitySelection={true}
                    reportLocated={"RIGHT"}
                  />
                </EmailProvider>
              </ApprovalProvider>
            </TreasuryKRISummaryProvider>
          </HedgeRatioProvider>
        )}
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default HRModelerAnalyticsGlobal;
